import React from 'react';
import { 
  StickyNote, 
  Type, 
  Square, 
  Copy, 
  Trash2,
  ArrowUp,
  ArrowDown
} from 'lucide-react';

export default function CanvasContextMenu({ 
  x, 
  y, 
  hasSelection, 
  canEdit,
  onAction, 
  onClose 
}) {
  const menuItems = canEdit ? [
    ...(hasSelection ? [] : [
      { id: 'sticky_note', icon: StickyNote, label: 'Add Sticky Note' },
      { id: 'text', icon: Type, label: 'Add Text' },
      { id: 'shape_rect', icon: Square, label: 'Add Rectangle' },
      { id: 'separator' }
    ]),
    ...(hasSelection ? [
      { id: 'duplicate', icon: Copy, label: 'Duplicate' },
      { id: 'separator' },
      { id: 'bring_front', icon: ArrowUp, label: 'Bring to Front' },
      { id: 'send_back', icon: ArrowDown, label: 'Send to Back' },
      { id: 'separator' },
      { id: 'delete', icon: Trash2, label: 'Delete', danger: true }
    ] : [])
  ] : [];

  // Close on click outside
  React.useEffect(() => {
    const handleClick = () => onClose();
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  if (menuItems.length === 0) return null;

  return (
    <div
      className="absolute bg-background rounded-lg border shadow-lg py-1 min-w-[160px] z-50"
      style={{ left: x, top: y }}
      onClick={(e) => e.stopPropagation()}
    >
      {menuItems.map((item, index) => {
        if (item.id === 'separator') {
          return <div key={`sep-${index}`} className="border-t my-1" />;
        }
        
        const Icon = item.icon;
        
        return (
          <button
            key={item.id}
            className={`w-full px-3 py-1.5 text-sm text-left flex items-center gap-2 hover:bg-accent transition-colors ${
              item.danger ? 'text-destructive hover:text-destructive' : ''
            }`}
            onClick={() => onAction(item.id)}
          >
            <Icon className="h-4 w-4" />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
